import { z } from "zod";
import { Id } from "./ids.js";

export const browserConnectionSchema = z.object({
  deviceId: Id,
  botId: Id,
  name: z.string(),
  connected: z.boolean(),
});
export type BrowserConnection = z.infer<typeof browserConnectionSchema>;

/** The local connector accepts browser operations only, never host commands or files. */
export const browserDeviceRequest = z.object({
  method: z.literal("browser"),
  botId: Id,
  spaceId: Id,
  operation: z.discriminatedUnion("type", [
    z.object({ type: z.literal("list") }),
    z.object({
      type: z.literal("call"),
      tool: z.string().min(1).max(80),
      args: z.record(z.string(), z.unknown()),
    }),
  ]),
});
export type BrowserDeviceRequest = z.infer<typeof browserDeviceRequest>;

export const browserConnectorConfig = z.object({
  serverUrl: z.string().url(),
  token: z.string().regex(/^[a-f0-9]{64}$/),
  deviceId: Id,
  botId: Id,
  spaceId: Id,
});
export type BrowserConnectorConfig = z.infer<typeof browserConnectorConfig>;
